// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b8cdd2cc] .item .duration{position:relative}[data-v-b8cdd2cc] .item .duration:after{content:\"小时\";position:absolute;display:block;clear:both;right:.52083vw;top:.3125vw;color:#7f7f7f;pointer-events:none}", ""]);
// Exports
module.exports = exports;
